export enum ErrorEnum {
  // main.ts
  INVALID_SSO_CODE = 'INVALID_SSO_CODE',
  INVALID_APP_CONFIG = 'INVALID_APP_CONFIG',
  IE11 = 'IE11',
  // common
  INTERNAL_SERVER_ERROR = 'INTERNAL_SERVER_ERROR',
  INVALID_FILE_EXTENSION = 'INVALID_FILE_EXTENSION',
  INVALID_FILE_NUMBER = 'INVALID_FILE_NUMBER',
  // results
  DUPLICATED_FILE_NAME = 'DUPLICATED_FILE_NAME',
  INVALID_UNIT_CONSISTENCY = 'INVALID_UNIT_CONSISTENCY',
  RADIONUCLIDE_NOT_FOUND = 'RADIONUCLIDE_NOT_FOUND',
  INVALID_RADIONUCLIDE_FORMAT = 'INVALID_RADIONUCLIDE_FORMAT',
  // analysis
  MISSING_NATURE_ATTRIBUTE = 'MISSING_NATURE_ATTRIBUTE',
  INVALID_NATURE_ATTRIBUTE = 'INVALID_NATURE_ATTRIBUTE',
  INVALID_SAMPLES_ATTRIBUTES = 'INVALID_SAMPLES_ATTRIBUTES',
  INVALID_SAMPLE_VALUES_NUMBER = 'INVALID_SAMPLE_VALUES_NUMBER',
  INVALID_SIZE_VALUE = 'INVALID_SIZE_VALUE',
  INVALID_SAMPLING_DATE_VALUE = 'INVALID_SAMPLING_DATE_VALUE',
  INVALID_SIZE_UNIT_VALUE = 'INVALID_SIZE_UNIT_VALUE',
  MISSING_VERSION_ATTRIBUTE = 'MISSING_VERSION_ATTRIBUTE',
  INVALID_VERSION_VALUE = 'INVALID_VERSION_VALUE',
  INVALID_SAMPLES_SIZE = 'INVALID_SAMPLES_SIZE',
  MISSING_SAMPLES = 'MISSING_SAMPLES',
  FILE_ALREADY_EXISTS = 'FILE_ALREADY_EXISTS',
  NO_FILE_PROVIDED = 'NO_FILE_PROVIDED',
  ANALYSIS_REQUEST_NOT_FOUND = 'ANALYSIS_REQUEST_NOT_FOUND',
  FILE_ACCESS_DENIED = 'FILE_ACCESS_DENIED',
  RESULT_FILE_NOT_FOUND = 'RESULT_FILE_NOT_FOUND',
  UNPUBLISHED_FILE_ACCESS_DENIED = 'UNPUBLISHED_FILE_ACCESS_DENIED'
}
